import { call, put, takeEvery } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import { addDays } from 'date-fns';
import { awsLoginRequest, signOut as signOutRequest } from 'utils/aws';
import { AuthConstants } from 'constants/auth';
import { requestPending, requestSuccess, requestFail, request } from 'components/Fetch';
import { get } from 'lodash';

function* signIn({ payload }) {
  try {
    yield put({
      type: requestPending(AuthConstants.AUTH_SIGN_IN),
    });
    const response = yield call(awsLoginRequest, { payload: payload.data });
    if (response.error === 'New password required') {
      yield put(push('/set-new-password'));
      yield put({
        type: requestFail(AuthConstants.AUTH_SIGN_IN),
        payload: new Error('New password required'),
      });
      localStorage.setItem('user.username', payload.data.username);
    } else {
      yield put({
        type: requestSuccess(AuthConstants.AUTH_SIGN_IN),
        payload: response,
      });

      const merchantId = get(response, ['idToken', 'payload', 'custom:merchant_id']);
      localStorage.setItem('merchantId', merchantId);

      if (merchantId) {
        localStorage.setItem('token', response.accessToken.jwtToken);
        localStorage.setItem('user.username', response.idToken.payload.preferred_username);
        localStorage.setItem('user.firstName', response.idToken.payload['custom:first_name'] || '');
        localStorage.setItem('user.lastName', response.idToken.payload['custom:last_name'] || '');
        localStorage.setItem('idToken', response.idToken.jwtToken);
        localStorage.setItem('refreshToken', response.refreshToken.token);
        localStorage.setItem('expiryTime', Date.now() + (3600 * 1000));
        localStorage.setItem('isTokenRefreshing', false);

        yield call(request({
          type: AuthConstants.GET_MERCHANT_ID,
          method: 'GET',
          url: `/merchants/${merchantId}/basic`,
          success: (res) => {
            if (get(res, 'status.code') === '1008'
              || get(res, 'status.code') === '1006'
              || get(res, 'status.code') === '1009'
              || get(res, 'status.code') === '1012'
            ) {
              localStorage.setItem('merchantStatus', get(res, 'status.code'));
              localStorage.setItem('merchantId', get(res, 'merchantId', ''));
              localStorage.setItem('businessName', get(res, 'businessName', ''));
              localStorage.setItem('subMerchants', get(res, 'subMerchants', '') ? JSON.stringify(get(res, 'subMerchants', '')) : null);
              let showPopup = false;
              if (get(res, 'userLastLoginDate')) {
                const lastLoggedDate = new Date(get(res, 'userLastLoginDate'));
                showPopup = new Date() > addDays(lastLoggedDate, 90);
              } else if (get(res, 'latestApplicationSubmittedDate')) {
                const latestApplicationSubmittedDate = new Date(get(res, 'latestApplicationSubmittedDate.date'));
                showPopup = new Date() < addDays(latestApplicationSubmittedDate, 90);
              }
              localStorage.setItem('merchantInfoPopup', showPopup);
              payload.success('success');
            } else {
              localStorage.clear();
              payload.fail({
                code: 'InvalidMerchant',
                message: 'Merchant is not valid!',
              });
            }
          },
        }));
        yield put({
          type: AuthConstants.UPDATE_LAST_LOGIN_DATE,
          payload: {
            merchantId,
            data: {
              userLastLoginDate: new Date(),
            },
          },
        });
      } else {
        localStorage.clear();
        payload.fail('Merchant Id does not exist');
      }
    }
  } catch (err) {
    yield put({
      type: requestFail(AuthConstants.AUTH_SIGN_IN),
      payload: err,
    });
    payload.fail(err);
  }
}

function* signOut() {
  signOutRequest();
  localStorage.clear();
  yield put({ type: requestSuccess(AuthConstants.AUTH_SIGN_OUT) });
  yield put(push('/'));
}

function* updateLastLoginDateSaga(action) {
  yield call(request({
    type: AuthConstants.UPDATE_LAST_LOGIN_DATE,
    method: 'PUT',
    url: `/merchants/${action.payload.merchantId}/user`,
  }), action);
}

export default function* () {
  yield takeEvery(AuthConstants.AUTH_SIGN_IN, signIn);
  yield takeEvery(AuthConstants.AUTH_SIGN_OUT, signOut);
  yield takeEvery(AuthConstants.UPDATE_LAST_LOGIN_DATE, updateLastLoginDateSaga);
}



// WEBPACK FOOTER //
// ./src/sagas/authSaga.js